import React from "react";
import { CardContent, Typography, Box, Stack, Divider } from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import { formatCurrency } from "../../utils/currencyUtils";
import { LedgerEntrySummaryDto } from "../../shared/dtos/ledgerEntry/LedgerEntrySummaryDto";

interface LedgerEntryCardProps {
  entry: LedgerEntrySummaryDto;
}

const LedgerEntryCard: React.FC<LedgerEntryCardProps> = ({ entry }) => {
  const isDebit = entry.debit > 0;

  return (
    <StyledCard>
      <CardContent>
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ color: "text.secondary", fontWeight: "bold" }}
          >
            {entry.accountCode} - {entry.accountName}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {new Date(entry.date).toLocaleString()}
          </Typography>
        </Stack>
        <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
          {entry.description}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", display: "block", mb: 2 }}
        >
          TXN: {entry.transactionId}
        </Typography>

        <Divider sx={{ mb: 1.5 }} />

        <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", display: "block" }}
            >
              Debit
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: isDebit ? "bold" : "normal",
                color: isDebit ? "info.main" : "text.primary",
              }}
            >
              {formatCurrency(entry.debit)}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "right" }}>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", display: "block" }}
            >
              Credit
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: !isDebit ? "bold" : "normal",
                color: !isDebit ? "warning.main" : "text.primary",
              }}
            >
              {formatCurrency(entry.credit)}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default LedgerEntryCard;
